// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tag-left[data-v-3f1c1da2] {\n  margin-right: 8px;\n}\n.foot[data-v-3f1c1da2] {\n  position: absolute;\n  bottom: 15px;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
